var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-container"},[_c('iframe',{staticClass:"faq-iframe",attrs:{"src":_vm.faqUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }